import React from 'react'
import store, { RootState } from '../store';
import { useAppSelector } from '../redux'
import { gameActions } from '../Game/gameSlice'

export default function PopUp() {
  const gameState = useAppSelector((state: RootState) => state.game)
  const popup = gameState?.popup

  function handleClose() {
    store.dispatch(gameActions.closePopup())
  }

  return (
    <>
      {popup.isVisible && popup.contentTop &&
        <div className="popup">
          <div className="modal" onClick={handleClose}>
            <div className="modal-content" onClick={(e) => { e.stopPropagation(); }}>
              <p>{popup.contentTop}</p>
              <p>{popup.contentBottom}</p>
              <div className="button-text center-text" onClick={handleClose}>Ok</div>
            </div>
          </div>
        </div>
      }
    </>
  )
}
